import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1a73e8',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#b71c1c',
        dark: '#051e34',
        topic1: '#003f5c',
        topic2: '#58508d',
        topic3: '#bc5090',
        topic4: '#ff6361',
      },
    },
  },
});
